package com.neurobs.js.http

import com.neurobs.errors.StringErrorReport
import com.neurobs.http
import org.scalajs.dom.Event
import org.scalajs.dom.ext.Ajax
import org.scalajs.dom.raw.{ProgressEvent, XMLHttpRequest}

import scala.concurrent.{ExecutionContext, Promise}
import scala.scalajs.js
import scala.scalajs.js.annotation.JSGlobal
import scala.scalajs.js.typedarray.{ArrayBuffer, Int8Array}
import scala.util.Try

@js.native
@JSGlobal
class TextDecoder(encoding: String) extends js.Object {
	def decode(buffer: ArrayBuffer): String = js.native
}

class StringBody(val data: String) extends http.BodyData {
	override def asString(): Option[String] = Some(data)
	override def asBytes(): Array[Byte] = data.getBytes
}

class ArrayBufferBody(val data: ArrayBuffer) extends http.BodyData {
	override def asString(): Option[String] = {
		val decoder = new TextDecoder(encoding = "utf-8")
		Try(decoder.decode(data)).toOption
	}

	override def asBytes(): Array[Byte] = {
		val temp = new Int8Array(data)
		temp.toArray
	}
}

case class AjaxDataSource(data: Ajax.InputData) extends http.DataSource

class XMLRequestProcess(req: XMLHttpRequest, promise: Promise[XMLHttpRequest]) extends http.RequestProcess {
	private var onProgress: Option[(Double) => Unit] = None
	def abort() : Unit = {
		if (!promise.isCompleted) {
			promise.failure(new Exception(""))
			req.abort
		}
	}
	def setOnProgress(fun: (Double) => Unit) : Unit = { onProgress = Some(fun) }
	req.upload.addEventListener(`type` = "progress", (e: ProgressEvent) => {
		onProgress.map { f =>
			val total = e.total
			val percent = if (total != 0) e.loaded / total else 0
			f(percent) }
	}, useCapture = false)
}

class XMLHttpRequestSession(implicit executor: ExecutionContext) extends http.Session {

	private var commonHeaders: Array[(String, String)] = Array()

	override def setCommonHeaders(headers: Iterable[(String, String)]): Unit = { commonHeaders = headers.toArray }

	override def call(url: String, t: http.HTTPRequestType.Value, body: http.DataSource = http.EmptyDataSource, binaryResponseExpected: Boolean): http.RequestCall[http.BodyData] = {

		val req = new XMLHttpRequest()
		// Need to create this here to make sure hookup of upload progress handler
		// is done before call to open
		val promise = Promise[XMLHttpRequest]()
		val requestProcess = new XMLRequestProcess(req, promise)

		try {
			req.onreadystatechange = (e: Event) => {
				if (req.readyState == 4) {
					if (!promise.isCompleted) {
						promise.success(req)
					}
				}
			}
			req.open(t.toString, url)
			for (h <- commonHeaders) req.setRequestHeader(h._1, h._2)
			if (binaryResponseExpected) {
				req.responseType = "arraybuffer"
			}
			//req.setRequestHeader("Csrf-Token", "nocheck")
			req.timeout = 0
			req.withCredentials = false

			val data: js.Any = body match {
				case http.StringDataSource(s) => s
				case http.EmptyDataSource => null
				case AjaxDataSource(d) => d
				//case _ => throw Exception("Unsupported data source type in XMLHttpRequestSession.call")
			}

			if (data == null) {
				req.send()
			}
			else {
				req.send(data)
			}
		}
		catch {
			case e: Throwable => promise.failure(e)
		}

		val res = promise.future map { r =>
			if (r.status == httpStatusOK) Right(
				if (binaryResponseExpected) new ArrayBufferBody(r.response.asInstanceOf[ArrayBuffer])
				else new StringBody(r.responseText)
			)
			else Left(http.HTTPResponseError(r.status))
		}
		(requestProcess, res)
	}
}